import { Modal } from 'antd';
import { radius } from '@libertify/ui';
import { useAntTheme } from '../hooks/useAntTheme';

export type LeadFormModalProps = {
  formUrl: string;
  open: boolean;
  onClose: () => void;
};

export const LeadFormModal = ({
  formUrl,
  open,
  onClose,
}: LeadFormModalProps) => {
  const { isMobile } = useAntTheme();
  const height = isMobile ? '75vh' : 600;
  const width = isMobile ? '90%' : 800;

  return (
    <Modal
      width={width}
      style={
        isMobile
          ? {
              top: 60, // 50px mobile header + 10px
            }
          : {}
      }
      styles={{
        content: { borderRadius: radius.box, padding: '0px 10px', height },
        body: { padding: 0, height },
      }}
      footer={null}
      open={open}
      onCancel={onClose}
    >
      <iframe
        title="form"
        style={{ border: 'none', width: '100%', height: '100%' }}
        src={formUrl}
      />
    </Modal>
  );
};
